import HeaderCell from './header-cell'
import TableStack from './table-stack'
import * as d3 from 'd3-selection'

/**
 * Encapsulates all the behavior and logic related to a stack with advanced layout
 */
class AdvancedLayoutStack extends TableStack {

	constructor(index, columnAttributes, layout, opts = {}) {
		super(index, columnAttributes, opts)

		this._headerCell = new HeaderCell(this, columnAttributes, this.options)
		this.setRow([this._headerCell], 0)

		this._layout = layout

		let formatter = (datum) => {
			return {
				tableStack: this,
				html: this._layout.html(cell => {
					return this.dataExtractor.toCellContents(datum, cell).html
				})
			}
		}
		this.setCellFormatters([formatter])
	}

	bindStackBodyDomNode(td) {
		this._bodyDomNodes.push(td)
		let self = this
		d3.select(td)
			.on('click', () => {
				this.emit('selectCell', this, td)
			})
			.selectAll('td')
			.on('click', function() {
				self.emit('selectAdvancedLayoutCell', this)
			})
	}

	/**
	 * Called on the start of the drag, performs any initialization required
	 * when a cell from this stack start a drag
	 */
	drag(dragCell, enable) {
	}

	/**
	 * Called when a entering/leaving a cell where a drop is accepted.  See base
	 * class table-stack.js for param documentation
	 */
	accept(args) {
	}

	/**
	 * Returns true if this stack is allowing in the dragged cell to be
	 * dropped on the drop cell
	 */
	allowDrop(dragCell, dropCell, zone) {
	}
}

export default AdvancedLayoutStack
AdvancedLayoutStack.__filename__ = 'reports/common/table/advanced-layout-stack.js'
